import React from 'react';
import useUser from '../hooks/useUser';
import ServerProductList from '../masters/server/ProductList';
import ClientProductList from '../masters/client/ProductList';

const ProductList = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    if (roleLower === 'gspos') {
        return <ServerProductList />;
    } else if (roleLower === 'client') {
        return <ClientProductList />;
    }
    return <ServerProductList />;
};

export default ProductList;
